export default __webpack_public_path__ + "static/media/PTweetsEdit3.3a6418d5.png";